type RefinedValue = {
  value: string;
  label: string;
};

export const findTranslationAmongItems = (
  items: readonly { value: string }[],
  { value, label }: RefinedValue
) => {
  const [name, code] = label.split('|');

  return items.find(
    item =>
      item.value !== value &&
      (item.value.endsWith(`|${code}`) || item.value.startsWith(`${name}|`))
  )?.value;
};

export const findSoleTranslation = (
  facetValues: string[],
  { value }: RefinedValue
) => {
  const [soleValue, ...otherValues] = facetValues;

  if (otherValues.length || soleValue === value) {
    return undefined;
  }

  return soleValue;
};
